<template>
    <v-card>
        <v-app-bar flat dense color="rgba(0, 0, 0, 0)">
            <v-toolbar-title> Variant Topping List </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="closeVariantToppingDialog" color="error" outlined small>
                <v-icon>mdi-close</v-icon></v-btn>
        </v-app-bar>

        <v-data-table :loading="loading" :headers="headers" :items="Variants.data" class="elevation-1"
            hide-default-footer>
            <template v-slot:no-data> No data </template>

            <template v-slot:[`item.actions`]="{ item }">
                <v-btn color="primary" outlined small @click.stop="selectVariantTopping(item)">Select <v-icon right> mdi-check
                    </v-icon></v-btn>
            </template>

            <template v-slot:[`item.is_active`]="{ item }">
                <v-icon v-if="item.is_active == 1" color="success">
                    mdi-check-circle
                </v-icon>
                <v-icon v-else color="error"> mdi-close-circle </v-icon>
            </template>
            <template v-slot:[`item.printing`]="{ item }">
                <v-icon v-if="item.printing == 1" color="success">
                    mdi-check-circle
                </v-icon>
                <v-icon v-else color="error"> mdi-close-circle </v-icon>
            </template>
            <template v-slot:[`item.perforation`]="{ item }">
                <v-icon v-if="item.perforation == 1" color="success" class="text-center">
                    mdi-check-circle
                </v-icon>
                <v-icon v-else color="error"> mdi-close-circle </v-icon>
            </template>
            <template v-slot:[`item.price`]="{ item }">
                <b>{{ item.price | currency("", 0, { symbolOnLeft: false, }) }}</b>
            </template>

            <template v-slot:top>
                <v-toolbar flat color="white">
                    <base-column :lg="4" :md="4" :sm="6">
                        <v-text-field v-model="search.search" append-icon="mdi-magnify" label="Search" outlined dense
                            hide-details></v-text-field>
                    </base-column>

                    <v-btn small color="darkblue" class="white--text float-end mx-1" @click.stop="searching">Submit <v-icon
                            right>mdi-magnify</v-icon></v-btn>
                    <v-btn small color="secondary" class="white--text float-end mx-1" @click.stop="clear">Clear
                        <v-icon right>mdi-close-circle-multiple </v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </template>
            <template>
                <v-icon color="warning" class="mr-2"> mdi-pencil-box-outline </v-icon>
            </template>
        </v-data-table>

        <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
    </v-card>
</template>
  
<script>
import { mapGetters, mapMutations } from "vuex";
import BaseColumn from "@/components/base/BaseColumn.vue";
export default {
    name: "MaterialModal",

    created() {
        this.getVariantTopping();
    },

    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Name", value: "name" },
                { text: "Price", value: "price" },
                { text: "Action", value: "actions", sortable: false, width: 100 },
            ],
            page: 1,
            expanded: [],
            loading: false,
            disabled: false,
            search: {
                search: null,
                status: "Active",
            },
        };
    },
    watch: {
        currentPage(newValue) {
            this.page = newValue;
            this.getVariantTopping();
        },
    },
    methods: {
        ...mapMutations("master_variant", ["SET_VARIANTS", "SET_CURRENT_PAGE"]),
        async getVariantTopping() {
            this.loading = true;
            let params = {
                page: this.page,
                search: this.search.search,
            };
            await this.$axios("/master/toppings", {
                params: params,
                headers: {
                    Authorization: this.$store.getters["auth/Token"],
                },
            }).then(({ data }) => {
                console.log(data.toppings.data);
                this.$store.commit("master_variant/SET_VARIANTS", data.toppings);
                this.loading = false;
                this.disabled = false;
            });
        },
        searching() {
            this.page = 1;
            this.getVariantTopping();
        },
        clear() {
            this.page = 1;
            this.search = {
                search: "",
            };
            this.getVariantTopping();
        },
        closeVariantToppingDialog() {
            this.$emit("closeVariantToppingDialog");
        },

        selectVariantTopping(item) {
            this.$emit("selectVariantTopping", item);
            this.closeVariantToppingDialog();
        },

        removeVariantTopping(item) {
            this.$emit("removeVariantTopping", item);
        },
    },
    computed: {
        ...mapGetters("master_variant", {
            Variants: "Variants",
        }),
        currentPage: {
            get() {
                return this.Variants.current_page;
            },
            set(val) {
                return this.$store.commit("master_variant/SET_CURRENT_PAGE", val);
            },
        },
        lastPage: {
            get() {
                return this.Variants.last_page;
            },
        },

    },

    components: {
        BaseColumn,
    },
};
</script>